export default __webpack_public_path__ + "static/media/plumbing-install.ff28a4aa.jpg";